import { gsap } from 'gsap/all'
import { store } from '../../../src/js/core/store.js'

export class ProjectCells {
  constructor () {
    this.projectCells = [...document.querySelectorAll('.js-project-cell')]
    if (this.projectCells.length <= 0) { return false }

    if (!store.isDevice) {
      this.projectCells.forEach(cell => {
        new ProjectCell(cell)
      })
    }
  }
}

class ProjectCell {
  constructor (element) {
    this.element = element
    this.line = this.element.querySelector('.js-project-line')
    this.image = this.element.querySelector('.js-project-image')
    this.duration = 0.5
    this.mouseover = false

    this.init()
  }

  init = () => {
    this.resize()
    this.bindEvents()
    this.setDefaults()
    this.createTimelines()
  }

  setDefaults = () => {
    gsap.set(this.line, { scaleX: 0, transformOrigin: 'left' })
    gsap.set(this.image, { transformOrigin: 'center' })
  }

  createTimelines = () => {
    this.createTimelineEnter()
    this.createTimelineLeave()
  }

  createTimelineEnter = () => {
    this.timelineEnter = new gsap.timeline({
      paused: true,
      onStart: () => {
        this.timelinePlaying = true
      },
      onComplete: () => {
        this.timelinePlaying = false

        if (!this.mouseover) {
          this.timelineLeave.restart()
        }
      }
    })

    this.timelineEnter
      .to(this.line, this.duration, { scaleX: 1, ease: 'power2.out' }, 'a')
      .to(this.image, this.duration, { scale: this.scale, ease: 'power2.out' }, 'a')
      .set(this.line, { transformOrigin: 'right' })
  }

  createTimelineLeave = () => {
    this.timelineLeave = new gsap.timeline({
      paused: true,
      onStart: () => {
        this.timelinePlaying = true
      },
      onComplete: () => {
        this.timelinePlaying = false
        if (this.mouseover) {
          this.timelineEnter.restart()
        }
      }
    })

    this.timelineLeave
      .to(this.line, this.duration, { scaleX: 0, ease: 'power2.out' }, 'a')
      .to(this.image, this.duration, { scale: 1, ease: 'power2.out' }, 'a')
      .set(this.line, { transformOrigin: 'right' })
  }

  bindEvents = () => {
    this.element.addEventListener('mouseenter', this.handleEnter)
    this.element.addEventListener('mouseleave', this.handleLeave)
    window.addEventListener('resize', this.resize)
  }

  handleEnter = () => {
    this.mouseover = true

    if (!this.timelinePlaying) {
      this.timelineEnter.restart()
    }
  }

  handleLeave = () => {
    this.mouseover = false

    if (!this.timelinePlaying) {
      this.timelineLeave.restart()
    }
  }

  resize = () => {
    this.imageRect = this.image.getBoundingClientRect()
    this.scale = (this.imageRect.width + 20) / this.imageRect.width
  }
}
